<template>
  <div>
    <Form ref="resourceApplicationForm" :model="resourceApplicationForm" :rules="ruleValidate" :label-width="140">
      <!-- 基本信息 -->
      <Row style="margin-bottom: 10px;">
        <Card>
          <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t( 'resourceLifecycle.queryResources' )}}</p>
          <Row style="margin-bottom: 10px;">
            <Col span="5" style="margin-right: 10px;">
              <Input search v-model="resourceApplicationForm.usageNote"
                     @on-search="searchLifecycleResourcesDate()" :placeholder="$t( 'resourceLifecycle.querybyPurpose' )"/>
            </Col>
            <Col span="5" style="margin-right: 10px;">
              <Input search v-model="resourceApplicationForm.resourceName"
                     @on-search="searchLifecycleResourcesDate()" :placeholder="$t( 'resourceLifecycle.querybyResourceName' )"/>
            </Col>
            <Col span="5" style="margin-right: 10px;">
              <Select v-model="resourceApplicationForm.resourceType" filterable  :transfer="true"
                      @on-change="searchLifecycleResourcesDate()" :placeholder="$t( 'resourceLifecycle.filterbyResourceType')">' )
                <Option :value="item.id" v-for="item in resourceTypeList" :key="item.id">{{item.name}}</Option>
              </Select>
            </Col>
          </Row>
          <Row :gutter="10" style="margin-bottom: 10px;">
            <Table :no-data-text="$t('common.noData')" ref="modalTable" :columns="columns" :data="lifecycleResourcesDate"></Table>
          </Row>
        </Card>
      </Row>

      <!-- 资源配置 -->
      <Row :gutter="10" style="margin-bottom: 10px;">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t( 'resourceLifecycle.resourceConfiguration' )}}</p>
            <Row :gutter="10" style="margin-bottom: 10px;">
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.flow' )" prop="approvalFlow">
                  <Select v-model="resourceApplicationForm.approvalFlow" filterable>
                    <Option :value="item.id" v-for="(item,index) in approvalFlowList" v-bind:key="item.id">
                      {{item.name}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row :gutter="10" style="margin-bottom: 10px;">
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.renewationPeriod' )" prop="periodOfUse">
                  <InputNumber v-model="resourceApplicationForm.periodOfUse" @on-change="calculatePrice"
                               :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
                  {{$t("resourceLifecycle.months")}}
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="22">
                <FormItem :label="$t( 'resourceLifecycle.exhibits' )" prop="enclosure">
                  <Upload ref="upload" v-model="resourceApplicationForm.enclosure" :on-success="uploadSuccess"
                          :on-error="uploadError" :headers='{"userName": userName}' multiple type="drag"
                          :action="actionUrl" :show-upload-list="true" :on-remove="handleRemove">
                    <div>
                      <Icon type="ios-cloud-upload" size="50" style="color: #3399ff"></Icon>
                      <p>{{$t( 'resourceLifecycle.clickordragthefiletouploadhere' )}}</p>
                    </div>
                  </Upload>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="22">
                <FormItem :label="$t( 'resourceLifecycle.remark' )" prop="describe">
                  <Input v-model="resourceApplicationForm.describe" type="textarea"
                         :autosize="{minRows: 2,maxRows: 10}"></Input>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <!-- 预估费用 -->
      <Row :gutter="10" style="margin-bottom: 10px;">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t( 'resourceLifecycle.estimatedcosts' )}}</p>
            <Row>
              <Col span="12">
                <FormItem :label="$t( 'resourceLifecycle.estimatedcost' )">
                  <i style="font-size: 20px;">￥ {{cost}}</i>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <FormItem style="float: right;">
        <!-- 提交 -->
        <Button type="primary" :loading="addLoading" @click="handleSubmit(resourceApplicationForm)">{{$t( 'resourceLifecycle.submit' )}}</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
  import {setCookie, getCookie, delCookie} from '../../../utils/cookieUtil.js'

  export default {
    name: 'ResourceBasicInformationSearch',
    components: {},
    data() {
      return {
        company: getCookie(global.companyId),
        resourceTypeList: [{
          id: 0,
          name: this.$t( 'resourceLifecycle.vMs' )
        }, {
          id: 1,
          name: this.$t( 'resourceLifecycle.virtualNetwork' )
        }, {
          id: 2,
          name: this.$t( 'resourceLifecycle.objectstorage' )
        }, {
          id: 3,
          name: this.$t( 'resourceLifecycle.manageddatabase' )
        }, {
          id: 4,
          name: this.$t( 'resourceLifecycle.elasticIP' )
        }, {
          id: 5,
          name: this.$t( 'resourceLifecycle.azureMySQLServer' )
        }, {
          id: 6,
          name: this.$t( 'resourceLifecycle.azureMariaDBServer' )
        }, {
          id: 7,
          name: this.$t( 'resourceLifecycle.azureRedisServer' )
        }],
        addLoading: false,
        actionUrl: '',
        userName: getCookie(global.cookieName),
        attachmentIDs: [],
        approvalFlowList: [],
        cost: 0,
        resourceApplicationForm: {
          resourceId: this.$route.query.id,
          accountId: '',
          region: '',
          usageNote: '',
          resourceName: '',
          resourceType: this.$route.query.lifecycleResourceType,
          accountTypeSearchKey: this.$route.query.platform,
          approvalFlow: '',
          periodOfUse: 1,
          duration: 0,
          cost: 0
        },
        ruleValidate: {
          approvalFlow: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselecttheflow' ), trigger: 'change', type: 'number'}
          ]
        },
        columns: [
          {
            title: this.$t( 'resourceLifecycle.selects' ),
            key: 'id',
            width: 70,
            align: 'center',
            render: (h, params) => {
              let id = params.row.id;
              let flag = false;
              let self = this
              if (this.resourceApplicationForm.resourceId === id) {
                flag = true
              } else {
                flag = false
              }
              return h('div', [
                h('Radio', {
                  props: {
                    value: flag
                  },
                  on: {
                    'on-change': () => {
                      self.resourceApplicationForm.resourceId = id;
                      self.resourceApplicationForm.resourceType = params.row.lifecycleResourceType
                      self.resourceApplicationForm.accountTypeSearchKey = params.row.platform
                      self.resourceApplicationForm.accountId = params.row.accountId
                      self.resourceApplicationForm.region = params.row.regionName
                      self.resourceApplicationForm.cost = params.row.cost
                      self.resourceApplicationForm.duration = params.row.duration
                      self.calculatePrice();
                    }
                  }
                })
              ])
            }
          },
          {
            title: this.$t( 'resourceLifecycle.uses' ),
            key: 'usageNote'
          },
          {
            title: this.$t( 'resourceLifecycle.platforms' ),
            key: 'platformString'
          },
          {
            title: this.$t( 'resourceLifecycle.zones' ),
            key: 'region'
          },
          {
            title: this.$t( 'resourceLifecycle.resourceName' ),
            key: 'lifecycleResourceName'
          },
          {
            title: this.$t( 'resourceLifecycle.resourceType' ),
            key: 'lifecycleResourceTypeDesc'
          },
          {
            title: this.$t( 'resourceLifecycle.surroundings' ),
            key: 'environmentDesc'
          },
          {
            title: this.$t( 'resourceLifecycle.periodmonths' ),
            key: 'duration'
          },
          {
            title: this.$t( 'resourceLifecycle.startdate' ),
            key: 'startDateStr'
          },
          {
            title: this.$t( 'resourceLifecycle.endDate' ),
            key: 'endDateStr'
          },
          {
            title: this.$t( 'resourceLifecycle.estimatedcostyuan' ),
            key: 'cost'
          }],
        lifecycleResourcesDate: []
      }
    },
    mounted: function () {
      // 上传附件接口
      this.actionUrl = process.env.API_ROOT + '/sme/file/uploadFileS3';
      this.selectListNames();
      //初始化参数
      if (this.$route.query.lifecycleResourceType != undefined) {
        this.searchLifecycleResourcesDate();
      }
    },
    watch: {
      cost: {
        handler(val) {
          this.changeCost(val);
        },
        immediate: true
      }
    },
    methods: {
      //计算预估价格
      calculatePrice: function () {
        var price = this.resourceApplicationForm.cost / this.resourceApplicationForm.duration
        this.cost = price * this.resourceApplicationForm.periodOfUse
        this.cost = this.cost.toFixed(2);
      },
      searchLifecycleResourcesDate: function () {
        this.$api.lifecycleResourceApplication.listLifecycleResource({
          "usageNote": this.resourceApplicationForm.usageNote,
          "lifecycleResourceName": this.resourceApplicationForm.resourceName,
          "lifecycleResourceType": this.resourceApplicationForm.resourceType
        })
          .then(res => {
            this.lifecycleResourcesDate = res.data;
          })
      },
      // 花费更改
      changeCost: function(val){
        // 只有冠闵用户才会启用该逻辑
        if (this.StringUtils.isNotEmpty(val) && this.StringUtils.isNotEmpty(this.company) && this.company == 1){
          this.$api.lifecycleResourceApplication.switchApprovalStreamsBasedByPrice({
            "price": val,
            "processTemplateType": 9
          }).then(res => {
            // 切换审批流
            this.resourceApplicationForm.approvalFlow = res.data.id;
          })
        }
      },
      // 审批流
      selectListNames: function () {
        this.$api.processTemplate.selectListNames({
          "type": 9
        })
          .then(res => {
            this.approvalFlowList = res.data;
            if(this.approvalFlowList.length>0){
              this.resourceApplicationForm.approvalFlow = this.approvalFlowList[0].id
            }
          })
      },
      /*********************附件*********************************/
      // 上传成功
      uploadSuccess(res, file, fileList) {
        this.$Message.success(this.$t("resourceLifecycle.response.uploadSuccess"));
        this.attachmentIDs.push(file.response.id);
        this.id = file.response.id;
      },
      // 上传失败
      uploadError(error, file) { //上传失败
        this.$Message.error(this.$t("resourceLifecycle.response.uploadFail"));
      },
      // 删除附件
      handleRemove(file, fileList) {
        this.$api.file.deleteAttatchment("id", file.response.id)
          .then(res => {
            this.$Message.success(this.$t("resourceLifecycle.response.deleteSuccess"));
            this.attachmentIDs = [];
            for (var i = 0; i < fileList.length; i++) {
              this.attachmentIDs.push(fileList[i].response.id)
            }
          })
      },
      // 提交
      handleSubmit: function (name) {
        var submitLifecycleResourceDTO = {
          "oldLifecycleResourceId": this.resourceApplicationForm.resourceId,
          "processTemplateId": this.resourceApplicationForm.approvalFlow,
          "attachmentIDs": this.attachmentIDs,
          "remark": this.resourceApplicationForm.describe,
          "duration": this.resourceApplicationForm.periodOfUse,
          "cost": this.cost
        };
        // 提交资源续约
        this.$api.lifecycleResourceApplication.submitLifecycleResourceRenew(submitLifecycleResourceDTO)
          .then(res => {
            this.$Message.success(this.$t("resourceLifecycle.response.renewSuccess"));
            this.$router.push({path: '/approvalTask', query: {t: Date.now()}});
          })
          .catch(error => {
            if (error.status == 500) {
              setTimeout(() => {
              }, 0)
            }
          })
      }
    }
  }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_renewal/ResourceBasicInformationSearch.vue